import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import "./billing.css";
import BillingData from "./billingData";
import BillingShowData from "./billingShowData";
import { FaInfo } from "react-icons/fa";
import Swal from "sweetalert2";

function Billing() {
  const [masterValueData, setMasterValueData] = useState("");
  const [error, setError] = useState("");
  const [showTables, setShowTables] = useState(false);
  const [showBillingForm, setShowBillingForm] = useState(false);
  const [showBillingShowData, setShowBillingData] = useState(false);
  const [viewBillingData, setViewBillingData] = useState("input");
  const [selectedHouses, setSelectedHouses] = useState({});
  const [facturarError, setFacturarError] = useState(false);
  const [isPedimentoChecked, setIsPedimentoChecked] = useState(false);
  const [visibleTables, setVisibleTables] = useState({
    first: false,
    second: false,
  });

  useEffect(() => {
    const checkAndShowPopup = async () => {
      const trimmedValue = masterValueData.trim();
      const pattern = /^\d{3}-\d+$/;

      if (isPedimentoChecked && pattern.test(trimmedValue)) {
        const requierePedimento = await hasHousesWithPedimento(trimmedValue);
        if (requierePedimento) {
          showPedimentoPopup();
        }
      }
    };

    checkAndShowPopup();
  }, [isPedimentoChecked]);

  const handleInputChangeBilling = (e) => {
    setMasterValueData(e.target.value);
    setError("");
  };

  const handleSearch = async () => {
    const pattern = /^\d{3}-\d+$/;
    const trimmedValue = masterValueData.trim();

    setError("");
    setFacturarError(false);
    setShowBillingForm(false);
    setVisibleTables({ first: false, second: false });

    if (trimmedValue === "") {
      setError("Debe ingresar una guía");
      return;
    }

    if (!pattern.test(trimmedValue)) {
      setError("Ingrese la guía correctamente");
      return;
    }

    // Validar si requiere mostrar pedimento
    if (isPedimentoChecked) {
      const requierePedimento = await hasHousesWithPedimento(trimmedValue);
      if (requierePedimento) {
        showPedimentoPopup();
        return;
      }
    }

    // Simulación de guías
    if (trimmedValue === "123-12341234") {
      setShowBillingForm(true);
    } else if (trimmedValue === "139-46864694") {
      setVisibleTables({ first: false, second: true });
    } else if (trimmedValue === "123-44448888") {
      setVisibleTables({ first: true, second: false });
    } else if (trimmedValue === "139-05050505") {
      setVisibleTables({ first: true, second: true });
    } else {
      setError("Error, la master no existe");
    }

    setShowTables(true);
  };

  const handleCheckboxChange = (index) => {
    setSelectedHouses((prev) => {
      const updated = { ...prev, [index]: !prev[index] };
      return updated;
    });
    setFacturarError(false);
  };

  const handleFacturar = () => {
    const atLeastOneSelected = Object.values(selectedHouses).some((val) => val);
    if (!atLeastOneSelected) {
      setFacturarError(true);
    } else {
      // setShowBillingForm("form");
      setShowBillingForm(true);
    }
  };

  const showPedimentoPopup = () => {
    Swal.fire({
      title: "Datos de la guía",
      html: `
      <div class="container-fluid swal-custom-content">
        <!-- Primera fila con 5 labels -->
        <div class="row mb-3 text-start">
          <div class="col-md-4 mb-4">
            <label><strong>AWB:</strong> 123-44447777</label>
          </div>
          <div class="col-md-4 mb-4">
            <label><strong>Piezas totales:</strong> 500</label>
          </div>
          <div class="col-md-4 mb-4">
            <label><strong>Peso total:</strong> 100</label>
          </div>
          <div class="col-md-4 mb-4">
            <label><strong>Piezas restantes:</strong> 50</label>
          </div>
          <div class="col-md-4 mb-4">
            <label><strong>Peso restantes:</strong> 250</label>
          </div>
        </div>

        <!-- Segunda fila con 3 inputs -->
        <div class="row mb-2 text-start">
          <div class="col-md-4 mb-2">
            <div class="form-group">
              <label for="factura"><strong>Piezas *</strong></label>
              <input type="text" class="form-control" id="factura" />
            </div>
          </div>
          <div class="col-md-4 mb-2">
            <div class="form-group">
              <label for="monto"><strong>Peso *</strong></label>
              <input type="number" class="form-control" id="monto" />
            </div>
          </div>
          <div class="col-md-4 mb-2">
            <div class="form-group">
              <label for="comentarios"><strong>No Pedimento *</strong></label>
              <input type="text" class="form-control" id="comentarios" />
            </div>
          </div>
        </div>
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: "Facturar",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "swal-wide alert-bg",
        title: "alert-title",
        confirmButton: "btn-amc-blue",
        cancelButton: "btn-amc-pink",
      },
      preConfirm: () => {
        const factura = document.getElementById("factura").value;
        const monto = document.getElementById("monto").value;
        const comentarios = document.getElementById("comentarios").value;
        return { factura, monto, comentarios };
      },
    }).then((result) => {
      // ✅ Desmarca el checkbox sin importar qué opción se elige
      setIsPedimentoChecked(false);

      if (result.isConfirmed) {
        console.log("Valores ingresados:", result.value);
        Swal.fire({
          title: "¡Facturado!",
          text: "La guía fue procesada.",
          icon: "success",
          iconColor: "#1B9925",
          customClass: {
            popup: "alert-bg",
            confirmButton: "btn-ok",
            title: "alert-title",
          },
        });
      }
    });
  };

  const hasHousesWithPedimento = async (guia) => {
    //Aqui se puede hacer la conexion al backend despues.
    const guiasConHouses = [
      "123-44447777",
      "139-05050505",
      "123-44448888",
      "123-12341234",
      "139-46864694",
    ];
    return guiasConHouses.includes(guia);
  };

  if (showBillingForm) {
    return <BillingData masterNumber={masterValueData} />;
  }

  if (showBillingShowData) {
    return <BillingShowData masterNumber={masterValueData} />;
  }

  return (
    <>
      <Helmet>
        <title>Horus | Búsqueda master</title>
      </Helmet>
      <ScrollToTop />

      <div className="container-fluid">
        {viewBillingData === "input" && (
          <div className="row justify-content-center">
            <div className="col-6">
              <label htmlFor="inputMaster" className="amc-label">
                Master
              </label>
              <input
                type="text"
                className="form-control"
                id="inputMaster"
                onChange={handleInputChangeBilling}
              />

              <div className="row mt-3">
                <div class="col-12">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="gridCheck"
                      checked={isPedimentoChecked}
                      onChange={(e) => setIsPedimentoChecked(e.target.checked)}
                    />
                    <label class="form-check-label" for="gridCheck">
                      Pedimento
                    </label>
                  </div>
                </div>
              </div>
              <div className="btns mt-3 d-flex justify-content-end gap-3">
                <button className="btnn" onClick={handleSearch}>
                  Buscar
                </button>
              </div>

              {error && (
                <div className="text-danger mt-2 text-end alert alert-danger text-center">
                  {error}
                </div>
              )}

              {/* {masterNotFound && (
                <div className="text-danger mt-2 text-end alert alert-danger text-center">
                  Error, la master no existe
                </div>
              )} */}
            </div>

            {/* Tablas aparecen aquí debajo cuando se da clic en "Buscar" */}
            {(visibleTables.first || visibleTables.second) && (
              <div className="row mt-4">
                <div className="col-12">
                  {visibleTables.first && (
                    <>
                      {/* tabla 1 */}
                      <table
                        className="table text-center mx-auto"
                        style={{ maxWidth: "900px", width: "100%" }}
                      >
                        <thead className="table fondo-head">
                          <tr>
                            <th>HBS</th>
                            <th>Fecha</th>
                            <th>Piezas</th>
                            <th>Peso</th>
                            <th>Piezas restantes</th>
                            <th>Peso restantes</th>
                            <th>Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[0, 1].map((index) => (
                            <tr key={index}>
                              <td>Dato 1</td>
                              <td>Dato 2</td>
                              <td>Dato 3</td>
                              <td>Dato 4</td>
                              <td>Dato 5</td>
                              <td>Dato 6</td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={selectedHouses[index] || false}
                                  onChange={() => handleCheckboxChange(index)}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <div className="row mt-4 mb-4">
                        <div
                          className="btns mt-3 d-flex justify-content-end gap-3 mx-auto"
                          style={{ maxWidth: "900px", width: "100%" }}
                        >
                          <button className="btnn" onClick={handleFacturar}>
                            Facturar
                          </button>
                        </div>
                        {facturarError && (
                          <div className="text-danger mt-2 text-end alert alert-danger text-center">
                            Debe de seleccionar al menos una house
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  {visibleTables.second && (
                    <>
                      {/* tabla 2 */}
                      <table
                        className="table text-center mx-auto"
                        style={{ maxWidth: "900px", width: "100%" }}
                      >
                        <thead className="table fondo-head">
                          <tr>
                            <th>House</th>
                            <th>Pedimento</th>
                            <th>Folio</th>
                            <th>Fecha</th>
                            <th>Piezas</th>
                            <th>Peso</th>
                            <th>Total</th>
                            <th>Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Dato 1</td>
                            <td>Dato 2</td>
                            <td>Dato 3</td>
                            <td>Dato 4</td>
                            <td>Dato 5</td>
                            <td>Dato 6</td>
                            <td>Dato 7</td>
                            <td>
                              <FaInfo
                                style={{ cursor: "pointer" }}
                                onClick={() => setShowBillingData(true)}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {viewBillingData === "form" && (
          <BillingData masterNumber={masterValueData} />
        )}
      </div>
    </>
  );
}

export default Billing;
